import React, { useState, useEffect } from "react";
import axios from '../helper/axios';
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useUser } from "../Provider";
import { useHistory } from 'react-router-dom';

const SearchSupplier = ({ onSupplierChange, hospitalvalue }) => {
    const { userrole1, token } = useUser();
    const [data, setManufacturer] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [openAutocomplete, setOpenAutocomplete] = useState(false);

    useEffect(() => {
        fetchManufacturerNames();
        setSelectedCategory("")
    }, [hospitalvalue, userrole1]);

    const fetchManufacturerNames = async () => {
        try {
          const response = await axios.get("/medicinemanufacturer", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              hospitalcode: hospitalvalue, // Use the selected hospital code
            },
          });
    console.log(response.data)
          if (response.status === 200) {
            setManufacturer(response.data);
          } else {
            console.error(`Failed to fetch available manufacturer name with status: ${response.status}`);
          }
        } catch (error) {
          console.error('Error fetching available manufacturer name:', error.message);
        }
      };
    const handleCategoryChange = (event, value) => {
        if (value) {
            setSelectedCategory(value);
            onSupplierChange(value);
        }
        else{
        setSelectedCategory("")
    }
    };
    const getOptionLabel = (option) => {
        // Handle the case when option is null or undefined
        return option?.suppliername || '';
    };
    const handleExpandClick = () => {
      setOpenAutocomplete(!openAutocomplete);
  };

    return (
        <div className="searchbar">
            <Autocomplete
                freeSolo
                id="free-solo"
                options={data}
                getOptionLabel={getOptionLabel }
                value={selectedCategory}
                onChange={handleCategoryChange}
                open={openAutocomplete}
                onOpen={() => setOpenAutocomplete(true)}
                onClose={() => setOpenAutocomplete(false)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        placeholder="Select Supplier"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleExpandClick}>
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                }
            />
        </div>
    );
};

export default SearchSupplier;